import React from 'react';
import { CMSContent } from '../components/cms/CMSContent';
import SEO from '../components/SEO';

/**
 * Cookie Policy — public page.
 * Rendered from Agreement Library key `cookie_policy` (Legal Corpus V1).
 * Cookie category preferences live in a separate route: /cookie-settings.
 */
const CookiePolicyPage = () => (
  <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-testid="cookie-policy-page">
    <SEO
      title="Cookie Policy"
      description="TreatX Cookie Policy — categories of cookies used across the platform, their purposes and how to manage preferences."
      canonicalPath="/cookie-policy"
    />
    <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-6 sm:p-8 lg:p-10">
      <CMSContent
        contentKey="cookie_policy"
        showTitle={true}
        showSummary={false}
        showLegalMetadata={true}
      />
    </div>
  </div>
);

export default CookiePolicyPage;
